// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1OmdP","footer":"ModalUpdate_footer__2rB-V"};